import dayjs from 'dayjs'
import React, { FC } from 'react'
import { TreatmentSurveyCard } from './TreatmentSurveyCard'
import { TreatmentSurveyItemComponentViewModel } from '../../types/treatmentItem.types'
import { useTreatmentPanelData } from '../TreatmentPanel/TreatmentPanelProvider'

interface Props {
  vm: TreatmentSurveyItemComponentViewModel
}

const TreatmentSurveyItemComponent: FC<React.PropsWithChildren<Props>> = ({
  vm,
}) => {
  const { survey } = vm

  const { showPastTreatmentItems } = useTreatmentPanelData()

  const date = survey.fillableFrom
  const isPast = dayjs().startOf('day') > dayjs(date)

  return !showPastTreatmentItems && isPast ? null : (
    <TreatmentSurveyCard vm={vm} />
  )
}

const TreatmentSurveyItem = React.memo(TreatmentSurveyItemComponent)

export { TreatmentSurveyItem }
